import Menu from './components/menu';
import { scrollAnimation } from './components/gsap.js';
import { lazyLoading } from './components/loading.js';

const menuElement = document.querySelector( '[data-menu]' );

if ( menuElement ) {
    const menu = new Menu( menuElement );
}

if (document.querySelector('[data-loading]')) {
    lazyLoading();
}

if (document.querySelector('[data-animation]')) {
    scrollAnimation();
}
